const entrepreneurFAQs = [
    {
        id: 1,
        question: "What is crowdfunding, and how can it help my business?",
        answer: "Crowdfunding is a way to raise capital for your business by securing small investments from a large number of people. Through our platform, you can reach potential investors who are interested in supporting your vision and business goals. It's a way to get funding while building a community of engaged backers.",
    },
    {
        id: 2,
        question: "What types of funding can I raise through your platform?",
        answer: "You can raise either equity-based or revenue-based funding. Equity-based crowdfunding offers investors a stake in your company, while revenue-based crowdfunding allows them to earn a percentage of your business’s revenue over time.",
    },
    {
        id: 3,
        question: "How much can I raise through crowdfunding?",
        answer: "On AQi’s platform, you can raise between $150k to $5 million under Regulation Crowdfunding (Reg CF). The amount depends on your goals, business needs, and investor interest.",
    },
    {
        id: 4,
        question: "What do I need to provide to start a campaign?",
        answer: "You'll need financial statements, your funding goals, a business plan, investment terms, and an overview of how you’ll use the funds. A pitch deck is great if you have one, and we’ll help you if you don’t.",
    },
    {
        id: 5,
        question: "How do I set an investment offering on your platform?",
        answer: "AQi guides you step by step through setting up your campaign and attracting investors. You’ll outline your business, your market, the problem you solve, and why you're the right team to solve it.",
    },
    {
        id: 6,
        question:
            "What are the costs involved in raising funds through your platform?",
        answer: "There are platform and transaction fees involved, which are clearly outlined before you launch your campaign. We prioritize transparency and value for your fundraising efforts.",
    },
    {
        id: 7,
        question: "How do I keep investors updated on my progress?",
        answer: "You can update investors through our platform, and we encourage quarterly updates. Transparency and communication help build investor trust and maintain engagement.",
    },
    {
        id: 8,
        question: "How long does it take to complete a crowdfunding campaign?",
        answer: "Campaigns typically last 45 to 60 days, but you can choose a duration that fits your business. Extensions are possible if you’re close to your goal.",
    },
    {
        id: 9,
        question: "Can I offer perks or rewards to my investors?",
        answer: "Yes! Offering early access, discounts, or other rewards can help attract and thank your investors. We encourage perks to boost campaign success.",
    },
    {
        id: 10,
        question: "What happens if my campaign doesn’t reach its funding goal?",
        answer: "You may not receive any funds if your campaign doesn’t meet its goal, depending on platform policies. Set realistic goals to increase your chances of success.",
    },
    {
        id: 11,
        question: "How do I attract investors to my campaign?",
        answer: "Build a strong pitch, tell your story, and use engaging visuals. Leverage your personal network and social media. AQi also provides resources to help you market your campaign.",
    },
    {
        id: 12,
        question: "How will investors receive updates on my business?",
        answer: "Investors get updates through the AQi platform. You’re expected to provide quarterly updates on milestones, revenue, and progress to maintain transparency and trust.",
    },
    {
        id: 13,
        question: "What happens after my campaign is successfully funded?",
        answer: "Funds are transferred to your business, and you’re expected to use them as outlined. You’ll also need to provide quarterly updates to your investors.",
    },
    {
        id: 14,
        question: "How do I handle investor relations?",
        answer: "Keep investors informed about your business, including milestones, financial health, and challenges. We help you develop communication strategies to keep investors engaged.",
    },
    {
        id: 15,
        question: "Can I raise funds from international investors?",
        answer: "No. Under Regulation Crowdfunding, only U.S. investors can participate in U.S.-based campaigns.",
    },
    {
        id: 16,
        question: "What are the tax implications of crowdfunding?",
        answer: "Tax implications depend on your business structure, the investment type, and the amount raised. Consult a tax professional for specific guidance.",
    },
    {
        id: 17,
        question: "How do I manage the legal aspects of fundraising?",
        answer: "AQi and its partners help you navigate legal requirements like SEC filings and investment contracts. You may also consult a lawyer to ensure full compliance.",
    },
    {
        id: 18,
        question: "Can I continue to raise funds in the future?",
        answer: "Yes. You can raise up to $5 million in a 12-month period under Reg CF. We’ll help plan future rounds in alignment with your growth and compliance needs.",
    },
    {
        id: 19,
        question: "What happens if I don’t meet my fundraising goal?",
        answer: "Depending on your agreement, you may or may not retain funds. Setting a realistic goal and staying engaged with investors improves your chances of success.",
    },
    {
        id: 20,
        question: "How can I promote my campaign and attract investors?",
        answer: "Use social media, email newsletters, and your network. AQi provides marketing tools and resources. Great content and attractive perks increase investor interest.",
    },
    {
        id: 21,
        question: "Do I need a business lawyer to set up my campaign?",
        answer: "It’s not required, but it’s recommended. AQi partners with experts who can assist you, or you can consult your own lawyer to ensure compliance with legal standards.",
    },
];

export default entrepreneurFAQs;
